import { TFunction } from '@mint-lib/i18n';
import { z } from 'zod';

import {
  StringWithMaxLength,
  StringWithMaxLengthRequired,
} from '../../utils/stringWithMaxLengthValidation.js';

const schema = (t: TFunction) =>
  z.object({
    name: StringWithMaxLengthRequired(t, 255),
    description: StringWithMaxLength(t, 255).optional().default(''),
  });

export const validationSchema = schema;

export type FormValues = z.input<ReturnType<typeof schema>>;
